"use client";

import { Tabs as MuiTabs, TabsProps as MuiTabsProps, Tab, TabProps } from "@mui/material";
import { FC } from "react";

interface TabsProps extends MuiTabsProps {
    tabs: TabProps[];
}

export const Tabs: FC<TabsProps> = ({ tabs, value, onChange, ...rest }) => {
    return (
        <MuiTabs value={value} onChange={onChange}{...rest}>
            {tabs.map(({ label, icon, ...rest }) => (
                <Tab label={label} key={String(label)} icon={icon} {...rest} />
            ))}
        </MuiTabs>
    );
};
